<template>
  <div class="match-2023p">
    <div id="app" style="min-width: 1160px; position: relative">
      <el-row
        class="bannerP-0204"
        onclick='javascript:window.open("http://univ.ciciec.com/col.jsp?id=116","_blank")'
      ></el-row>
      <!-- 赛事简洁 -->
      <el-row class="pd60-0204 fpga-wrapper" id="ssjj-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204">
            <span class="title-font28-span">赛事简介</span>
          </el-row>
          <div class="ins-box">
            <img
              class="fpga-ins-img"
              src="@/assets/myMatch/ciciec2023/introduce20220314.jpg"
              alt=""
            />
            <el-row class="ins-text-fpga">
              <div>
                2023年1月5日，海云捷迅执行承办的第七届全国大学生集成电路创新创业大赛启动仪式在线上举行。该活动由工业和信息化部人才交流中心主办，重庆西永微电子产业园区承办，示范性微电子学院产学融合发展联盟、IEEE中国代表处、北京电子学会协办，北京智芯国信科技有限公司运营。
              </div>
              <br />
              <div>
                作为本次大赛的执行承办方，海云捷迅将提供最新一代人工智能边缘实验平台作为本次大赛的赛事平台，并参与赛题设置。海云捷迅将倾力参与到大赛中，为参赛团队提供服务。
              </div>
            </el-row>
          </div>
        </el-row>
      </el-row>
      <!-- 精彩资讯 -->
      <el-row class="pd60-0204" id="jczx-mlj" style="background-color: #f5f6f9">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204 title-font28-0204-margin"
            ><span class="title-font28-span">精彩资讯</span></el-row
          >
          <el-row class="title-text-0204" style="color: #999999"
            >实时传递大赛最新动态</el-row
          >
          <div style="display: flex">
            <div class="lbt-btn">
              <i class="icon iconfont icon-fj-chevron-left"></i>
            </div>
            <div class="swiper-container" style="margin: 0 10px">
              <div class="swiper-wrapper">
                <!-- 2023-3-13 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5336','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2023/2023-0224.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="共襄盛举丨2023春季全国集成电路产教融合高峰论坛合作招募中"
                      >
                        共襄盛举丨2023春季全国集成电路产教融合高峰论坛合作招募中
                      </div>
                      <div class="date">2023-02-24</div>
                      <div
                        class="description"
                        title="2023春季全国集成电路产教融合高峰论坛合作招募中"
                      >
                        2023春季全国集成电路产教融合高峰论坛合作招募中
                      </div>
                      <div class="description"><br /></div>
                      <!-- <div class="description"><br/></div> -->
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5326','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2023/2023-0217.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="喊你一声“少年英雄”你敢答应吗？第七届集创赛“海云捷迅杯”，等你来战！"
                      >
                        喊你一声“少年英雄”你敢答应吗？第七届集创赛“海云捷迅杯”，等你来战！
                      </div>
                      <div class="date">2023-02-17</div>
                      <div
                        class="description"
                        title="第七届集创赛“海云捷迅杯”报名开启"
                      >
                        第七届集创赛“海云捷迅杯”报名开启
                      </div>
                      <div class="description"><br /></div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <!-- 2023-1-13 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5286','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2023/2023011301.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="“逐梦芯时代，青春正当燃”第七届全国大学生集成电路创新创业大赛启动仪式顺利举行"
                      >
                        “逐梦芯时代，青春正当燃”第七届全国大学生集成电路创新创业大赛启动仪式顺利举行
                      </div>
                      <div class="date">2023-01-10</div>
                      <div
                        class="description"
                        title="第七届全国大学生集成电路创新创业大赛启动仪式顺利举行"
                      >
                        第七届全国大学生集成电路创新创业大赛启动仪式顺利举行
                      </div>
                      <div class="description"><br /></div>
                      <!-- <div class="description"><br/></div> -->
                    </div>
                  </div>
                </div>
                <!-- 2023-1-6 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5269','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2023/202301061.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="逐梦芯时代 青春正当燃——2023第七届集创赛即将启动"
                      >
                        逐梦芯时代 青春正当燃——2023第七届集创赛即将启动
                      </div>
                      <div class="date">2023-01-04</div>
                      <div
                        class="description"
                        title="2023第七届集创赛启动仪式在线直播。"
                      >
                        2023第七届集创赛启动仪式在线直播。
                      </div>
                      <div class="description"><br /></div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
                <!-- 2022-10-9 增加内容 -->
                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5155','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2023/202210092.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第六届集创赛“海云捷迅杯”全国总决赛获奖名单公布"
                      >
                        第六届集创赛“海云捷迅杯”全国总决赛获奖名单公布
                      </div>
                      <div class="date">2022-09-08</div>
                      <div
                        class="description"
                        title="全国总决赛获奖名单公布（盖章版）"
                      >
                        全国总决赛获奖名单公布（盖章版）
                      </div>
                      <div class="description"><br /></div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>

                <div class="swiper-slide">
                  <div
                    class="lbt-li-0204"
                    onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=5137','_blank')"
                  >
                    <div class="top">
                      <img
                        src="@/assets/myMatch/ciciec2023/202210092.jpg"
                        height="227px"
                      />
                    </div>
                    <div class="bottom">
                      <div
                        class="title"
                        title="第六届集创赛“海云捷迅杯”全国总决赛答辩评审在重庆顺利举行"
                      >
                        第六届集创赛“海云捷迅杯”全国总决赛答辩评审在重庆顺利举行
                      </div>
                      <div class="date">2022-08-26</div>
                      <div
                        class="description"
                        title="第六届全国大学生集成电路创新创业大赛“海云捷迅杯”全国总决赛答辩评审在重庆以线上方式举行"
                      >
                        第六届全国大学生集成电路创新创业大赛“海云捷迅杯”全国总决赛答辩评审在重庆以线上方式举行
                      </div>
                      <div class="description"><br /></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="lbt-btn">
              <i class="icon iconfont icon-fj-chevron-right"></i>
            </div>
          </div>
          <el-row style="margin-top: 30px">
            <div class="title-button">
              <a
                href="http://univ.ciciec.com"
                target="_blank"
                class="title-link"
                >进入集创赛官网了解更多</a
              >
            </div>
          </el-row>
        </el-row>
      </el-row>

      <!-- 海云捷讯杯 -->
      <div id="awcloudCup">
        <div class="awcloudCup_center">
          <!-- 海云捷迅杯 -->
          <div class="awcloudCup_title">
            <div class="awcloudCup_titleTop">
              <div class="title-font28-0204 title-font28-0204-margin">
                <span class="title-font28-span">海云捷迅杯</span>
              </div>
            </div>
            <div class="awcloudCup_titleBottom">
              海云捷迅作为企业代表参与赛题设置，大赛中开设"海云捷迅杯"赛道
            </div>
          </div>
          <!-- 杯赛题目 -->
          <div class="awcloudCup_subject">
            <ul class="awcloudCup_subjectTop">
              <li class="awcloudCup_subjectTopLeft">
                <div class="awcloudCup_subjectImg"></div>
                <h3 class="awcloudCup_subjectTitle">杯赛题目</h3>
              </li>
              <li class="awcloudCup_subjectTopRight">
                <div class="awcloudCup_subjectImg"></div>
                <h3 class="awcloudCup_subjectTitle">参赛组别</h3>
              </li>
            </ul>
            <ul class="awcloudCup_subjectBottom">
              <li class="awcloudCup_subjectBottomLeft">
                基于FPGA机器视觉缺陷检测的实现
              </li>
              <li
                class="awcloudCup_subjectBottomRight"
                style="color: #333; font-weight: bold; line-height: 34px"
              >
                A组、B组
              </li>
            </ul>
          </div>
          <!-- 设计任务 -->
          <div class="awcloudCup_task">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>设计任务</div>
            </el-row>
            <ul class="awcloudCup_taskBottom">
              <li>
                本赛项涉及的机器视觉系统是工业自动化关键技术，机器视觉系统在制造业升级为智能制造的过程中发挥了重要作用。
              </li>
              <li>
                本次杯赛要求选手通过获取PL端摄像头数据，完成图像预处理，使用提供的模型和CNN加速器进行推理，并将推理结果叠加到原视频流，通过PL端HDMI接口进行输出。
              </li>
              <li>
                使用带框架的FPGA
                AI加速器，虽然比较便利，但是会消耗一定的时间来处理框架开销，会降低加速器性能，影响视频流输出显示的帧率。
              </li>
              <li>
                我们鼓励选手对AI框架进行深度优化，从而更高效的利用CNN加速器。同时鼓励选手自行设计PL端CNN加速器，以获得更高的帧率输出。
              </li>
            </ul>
          </div>
          <!-- 设计指标 -->
          <div class="awcloudCup_task">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>设计指标</div>
            </el-row>
            <ul class="awcloudCup_taskBottom">
              <li>
                1.本次比赛全程可使用提供的AIEP（人工智能边缘实验平台）作为赛题硬件平台，如果有特殊需要，可申请使用开发板；
              </li>
              <li>
                2.如有选手需要进行模型训练，需使用自己的笔记本或台式机，也可以使用百度飞桨AI
                Studio等算力平台；
              </li>
              <li>3.HDMI输出刷新帧率不低于1FPS；</li>
              <li>4.推理结果刷新速度不低于1FPS；</li>
              <li>
                5.可自行选用合适的模型(我们会提供基于SSD-MobileNetV1的Demo)；
                <br />
                <span> (1) 可利用提供的缺陷数据集进行模型训练和部署；</span>
                <br />

                <span>
                  (2)
                  训练出的模型，对提供的缺陷样本推理准确度至少达到80%；</span
                >
                <br />

                <span>
                  (3)
                  训练好的模型，需要成功在AIEP（FPGA开发板）上部署并获得结果输出。</span
                >
              </li>
            </ul>
          </div>
          <!-- 附加题 -->
          <div class="awcloudCup_task" style="padding-bottom: 45px">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>附加题</div>
            </el-row>
            <ul class="awcloudCup_taskBottom" style="padding-bottom: 0">
              <li style="margin-bottom: 0">
                推理部分方案使用到FPGA
                PL端加速，并且在文档和答辩中进行充分描述和证明。
              </li>
            </ul>
            <div class="awcloudCup_taskBottomTable">
              <table>
                <thead>
                  <tr>
                    <th class="awcloudCup_taskBottomPerformance">分值</th>
                    <th class="awcloudCup_taskBottomScore">说明</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>15分</td>
                    <td>
                      使用FPGA
                      PL端加速器，并在提交资料及汇报中清晰例证，可得15分
                    </td>
                  </tr>
                  <tr>
                    <td>0~35分</td>
                    <td>
                      自行设计的FPGA
                      PL端加速器设计合理、功能模块层次清晰，接口简单，并在提交资料及汇报中清晰例证
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 提交内容 -->
          <div class="awcloudCup_task">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>提交内容</div>
            </el-row>
            <div style="font-weight: bold">初赛阶段</div>
            <ul class="awcloudCup_taskBottom">
              <li>
                1. 汇报PPT：项目介绍；关键技术介绍、提升点、数据统计；性能指标
              </li>
              <li>2. 详细设计方案：系统架构分析、关键技术分析、性能分析</li>
              <li>3. 仿真以及测试报告</li>
              <li>4. 工程源码</li>
              <li>5. 效果演示视频</li>
            </ul>
            <div style="font-weight: bold">分赛区决赛及总决赛阶段</div>
            <ul class="awcloudCup_taskBottom">
              <li>
                1.
                现场汇报PPT：项目介绍；关键技术介绍、提升点、数据统计；仿真及测试过程例证、呈现；性能指标
              </li>
              <li>2. 详细设计方案：系统架构分析、关键技术分析、性能分析</li>
              <li>3. 仿真以及测试报告</li>
              <li>4. 现场效果演示</li>
            </ul>
          </div>
          <!-- 评分标准 -->
          <div
            class="awcloudCup_task"
            style="margin-bottom: 60px; padding-bottom: 45px"
          >
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>评分标准</div>
            </el-row>
            <!-- 评分标准表 -->
            <div class="awcloudCup_SorePip">
              <table>
                <thead>
                  <tr>
                    <th class="awcloudCup_SorePipContent">项目</th>
                    <th class="awcloudCup_SorePipContent">内容</th>
                    <th class="awcloudCup_SorePipSore">分值</th>
                    <th class="awcloudCup_SorePipRequire">评分要求</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowspan="3" class="awcloudCup_SorePipBac">
                      基本指标(30分)
                    </td>
                    <td rowspan="2">可正常运行</td>
                    <td>10分</td>
                    <td>程序正常部署、正常运行并能正常进行可视化输出</td>
                  </tr>
                  <tr>
                    <td>0</td>
                    <td>程序无法正常部署、正常运行，或无法进行可视化输出</td>
                  </tr>
                  <tr>
                    <td>能准确识别(10份推理样本)</td>
                    <td>20</td>
                    <td>对提供的缺陷样本推理准确度达到10份；</td>
                  </tr>

                  <tr>
                    <td rowspan="2" class="awcloudCup_SorePipBac">
                      性能指标(40分)
                    </td>
                    <td>HDMI刷新速度</td>
                    <td>15分</td>
                    <td>
                      HDMI刷新速度达到1帧/秒，可得基础分5分；每超出100ms，扣1分，0分为限；每增加1帧，加0.35分，刷新速度≥30帧，得15分满分
                    </td>
                  </tr>

                  <tr>
                    <td>推理刷新速度</td>
                    <td>25分</td>
                    <td>
                      推理刷新速度达到1帧/秒，可得基础分5分；每超出100ms，扣0.5分，0分为限；每减少30ms，加0.7分，25分为限
                    </td>
                  </tr>

                  <tr>
                    <td rowspan="3" class="awcloudCup_SorePipBac">
                      设计完整性(10分)
                    </td>
                    <td>设计方案</td>
                    <td>3分</td>
                    <td>设计方案原理合理、逻辑清晰</td>
                  </tr>

                  <tr>
                    <td>仿真、测试报告</td>
                    <td>4分</td>
                    <td>
                      详细且充分的仿真、测试报告；对整个方案实现提供详尽的数据支撑
                    </td>
                  </tr>

                  <tr>
                    <td>工程源码</td>
                    <td>3分</td>
                    <td>工程源码完整；进行了详尽的注释说明</td>
                  </tr>

                  <tr>
                    <td rowspan="4" class="awcloudCup_SorePipBac">
                      汇报及答辩(20分)
                    </td>
                    <td>汇报PPT</td>
                    <td>5分</td>
                    <td>汇报PPT重点突出、条理清晰</td>
                  </tr>

                  <tr>
                    <td>方案描述</td>
                    <td>5分</td>
                    <td>方案原理分析合理、逻辑清晰</td>
                  </tr>

                  <tr>
                    <td>仿真、测试描述</td>
                    <td>5分</td>
                    <td>
                      对开发过程中仿真、测试进行合理描述，对方案实现过程进行数据支撑，描述简单明了、抓住重点
                    </td>
                  </tr>

                  <tr>
                    <td>现场表现</td>
                    <td>5分</td>
                    <td>答辩和文档表现优秀</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <button
            class="awcloudCup_SorePipEnroll"
            style="outline: none"
            onclick="javascript:window.open('https://www.saikr.com/vse/univ/ciciec/7','_blank')"
          >
            立即报名
          </button>
          <!-- <el-row>
                <div style="margin: 60px 0;background-color: #ccc;" class="btn-gwbm">报名已结束</div>
            </el-row> -->
        </div>
      </div>

      <!-- FPGA培训 -->
      <el-row class="pd60-0204 fpga-wrapper" id="fpga-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204"
            ><span class="title-font28-span">FPGA培训</span></el-row
          >
          <el-row class="title-text-fpga">
            FPGA培训以FPGA人工智能方向为主，依托业内领先的FPGA技术，为人工智能及大数据、云计算等关联领域培养技能型人才。
            培训以企业全案例训练为主要特色，面向学员有针对性的提供FPGA培训课程，课程直切企业需求，培养软件+硬件复合型人才，旨在为行业培养实战型专业人才。
            FPGA培训将就业贯穿学员培养的全过程，实现学员个人职业生涯的可持续发展；依托海云捷迅人工智能领域的合作伙伴及FPGA生态企业，组织专场招聘会和双选会，为企业输送优秀人才，保障学员就业
          </el-row>
          <el-row>
            <ul style="display: flex; margin-top: 30px">
              <li class="fpga-li">
                <div class="fpga-bg-box fpga-bg-one"></div>
                <div class="fpga-bottom-title">课堂教学</div>
              </li>
              <li class="fpga-li">
                <div class="fpga-bg-box fpga-bg-two"></div>
                <div class="fpga-bottom-title">专场招聘</div>
              </li>
              <li class="fpga-li">
                <div class="fpga-bg-box fpga-bg-three"></div>
                <div class="fpga-bottom-title">生活学习</div>
              </li>
              <li class="fpga-li" style="margin-right: 0px">
                <div class="fpga-bg-box fpga-bg-four"></div>
                <div class="fpga-bottom-title">素质拓展</div>
              </li>
            </ul>
          </el-row>
          <el-row style="margin-top: 30px">
            <div class="title-button">
              <a href="https://fpgaba.com/" target="_blank" class="title-link"
                >了解更多培训信息</a
              >
            </div>
          </el-row>
        </el-row>
      </el-row>
      <!-- 实训场景 -->
      <el-row class="pd60-0204 sx-wrapper" id="sxcj-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204"
            ><span class="title-font28-span">实训场景</span></el-row
          >
          <el-row class="sx-box">
            <div class="sx-left sx-bg-one"></div>
            <div class="sx-right">
              <el-row
                class="content-col18"
                style="width: 100%; margin-bottom: 0"
              >
                <div class="content-col18-bg"></div>
                <div>农业智联网实训沙盘</div>
              </el-row>
              <div class="sx-title">
                农业智联网实训场景是以农业大棚为背景定制的一套微缩立体沙盘，涵盖人工智能、物联网、FPGA、Web开发等技术领域，
                可实现包括人工智能机器视觉技术的农作物病害检测、传感器数据收集及分析、FPGA入侵检测和反向自动控制等功能。
                通过可视化的监控大屏、移动端APP实现对大棚环境实时显示、状态查询、远程控制等操作。结合教学内容与实际产业、岗位需求，
                该实训套件能提供丰富的实验课程及配套资源，让学生快速掌握相关技能知识，加强对行业需求的理解和认知。
              </div>
            </div>
          </el-row>
          <el-row class="sx-box">
            <div class="sx-left sx-bg-two"></div>
            <div class="sx-right">
              <el-row
                class="content-col18"
                style="width: 100%; margin-bottom: 0"
              >
                <div class="content-col18-bg"></div>
                <div>工业缺陷检测实训套件</div>
              </el-row>
              <div class="sx-title">
                工业缺陷检测实训套件是以工业互联网铝表面缺陷检测应用为背景，面向高校人工智能、FPGA等相关专业的实训产品。
                为贴合真实应用场景，本产品加入专业的工业相机、光源、传送带、机械臂形成一套完整的智能检测应用系统，实现基于FPGA的数据推理、机械臂自动分拣和检测数据可视化展示等功能。
                产品利用YOLOv3深度学习算法和铝片表面缺陷数据集，并使用FPGA来运行模型应用，可检测铝表面划痕、针孔、褶皱、污损等4种缺陷类型，用户可二次开发增加缺陷种类。
              </div>
            </div>
          </el-row>
          <el-row class="sx-box" v-if="showMore">
            <div class="sx-left sx-bg-three"></div>
            <div class="sx-right">
              <el-row
                class="content-col18"
                style="width: 100%; margin-bottom: 0"
              >
                <div class="content-col18-bg"></div>
                <div>农业智联网实训套件</div>
              </el-row>
              <div class="sx-title">
                农业智联网实训套件结合传感器数据采集、数据传输、图像处理、智能化分析、反向自动控制等技术，通过监控大屏对农作物环境信息进行可视化展示，
                并将历史环境数据生成曲线走势图，方便用户直观了解环境变化趋势，也可以通过监控大屏的灯光控制按钮反向控制灯光照明。
                针对农作物种植过程中的病害问题，使用农作物病害样本集，基于YOLOv3算法模型训练得到农作物病害识别的智能算法模型，利用VPU芯片进行农作物病害实时检测并在大屏中展示检测结果，显示病因并提出防治方法。
              </div>
            </div>
          </el-row>
          <el-row class="sx-box" v-if="showMore">
            <div class="sx-left sx-bg-four"></div>
            <div class="sx-right">
              <el-row
                class="content-col18"
                style="width: 100%; margin-bottom: 0"
              >
                <div class="content-col18-bg"></div>
                <div>病害检测系统</div>
              </el-row>
              <div class="sx-title">
                病害检测系统是以农作物健康状态检测为背景，基于人工智能技术方向提供的软硬一体化实训产品。
                产品使用农作物病害样本集，利⽤YOLOv3⽬标检测算法进行训练，将最终输出模型作为系统的检测分类器，通过VPU芯片对农作物病害情况进行实时检测。
                当摄像头采集到农作物叶子图像时，系统可自动判叶子的种类及病害情况，并在Web页面对病害状况进行可视化展示。
                对有病害的农作物，通过文字标注相应的病害名称和防治方法，帮助农户做好病害预警。
              </div>
            </div>
          </el-row>
          <el-row class="sx-box" v-if="showMore">
            <div class="sx-left sx-bg-five"></div>
            <div class="sx-right">
              <el-row
                class="content-col18"
                style="width: 100%; margin-bottom: 0"
              >
                <div class="content-col18-bg"></div>
                <div>无人车实训套件</div>
              </el-row>
              <div class="sx-title">
                无人车实训套件是集自动控制、人工智能、FPGA、视觉计算等技术领域，面向高校人工智能相关专业提供的软硬一体的教学实训产品。
                系统搭载ARM、GPU、FPGA三大异构算力芯片，整合了ROS机器人操作系统平台，利用雷达测距原理、SLAM即时定位与地图构建、视觉计算、深度学习技术，
                实现无人车自动驾驶、交通标识牌识别、路径规划、目标跟踪等功能。
                支持通过手机APP对无人车进行状态查询和线路构建。
              </div>
            </div>
          </el-row>
          <el-row class="sx-box" v-if="showMore">
            <div class="sx-left sx-bg-six"></div>
            <div class="sx-right">
              <el-row
                class="content-col18"
                style="width: 100%; margin-bottom: 0"
              >
                <div class="content-col18-bg"></div>
                <div>画像风格迁移系统</div>
              </el-row>
              <div class="sx-title">
                画像风格迁移系统内置画像风格迁移（Fast-style-transfer）算法，对摄像头采集的真实图像和输入的风格图像通过神经网络深度运算，渲染成具有艺术风格迁移的图像，
                并通过画屏对风格迁移后的画像进行可视化展示。用户可通过照片打印机，对渲染后的画像快速打印成照片用作留念。结合该产品，可以帮助学生掌握画像风格迁移基础知识，熟悉模型依赖环境，
                了解模型推理过程，学习处理数据集方法，加深对图像处理、人工智能等技术的理解和认知。
              </div>
            </div>
          </el-row>
          <el-row
            style="
              margin-top: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div class="sx-botton" @click="showMore = !showMore">{{showMore ? '收起': '展开更多'}}</div>
            <img
              v-if="!showMore"
              src="@/assets/myMatch/ciciec2023/sxcj_btn_unfold.png"
              alt=""
              class="sxcj-btn-unfold"
            />
            <img
              v-if="showMore"
              src="@/assets/myMatch/ciciec2023/sxcj_btn_fold.png"
              alt=""
              class="sxcj-btn-fold hide"
            />
          </el-row>
        </el-row>
      </el-row>
      <!-- 赛事平台 -->
      <el-row class="pd60-0204 sspt-wrapper" id="sspt-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204 title-font28-0204-margin"
            ><span class="title-font28-span">赛事平台</span></el-row
          >
          <el-row class="title-text-0204"
            >海云捷迅提供人工智能边缘实验平台作为本次大赛的赛事平台</el-row
          >
          <el-row class="content-col18">
            <div class="content-col18-bg"></div>
            <div>赛事平台-人工智能边缘实验平台</div>
          </el-row>
          <el-row class="font14-0204 mgb10-0204"
            >该平台是由海云捷迅研发的云+FPGA+AI综合性平台</el-row
          >
          <el-row class="content-col14 mgb10-0204">
            <div class="content-col14-bg"></div>
            <div class="font14-0204">
              云端访问，使用SoC网络技术和FPGA远程调试技术，通过云端向参赛队伍提供服务，参赛队伍可以远程接入此平台，仿真、调试。
            </div>
          </el-row>
          <el-row class="content-col14 mgb10-0204">
            <div class="content-col14-bg"></div>
            <div class="font14-0204">
              FPGA，自主研发的人工智能边缘实验平台，将多个FPGA板卡放置在同一个机箱中，为其提供电源接口、网络分配管理单元，形成FPGA资源池，板卡使用的C5
              SoC的FPGA。
            </div>
          </el-row>
          <el-row class="content-col14">
            <div class="content-col14-bg"></div>
            <div class="font14-0204">
              AI，FPGA开发板内置了与百度开源深度学习Paddle-Paddle框架对接的驱动以及FPGA加速器Demo文件，参赛团队可以方便的将模型文件部署到结合Paddle-Paddle框架的FPGA上，
            </div>
          </el-row>
          <el-row class="font14-0204" style="margin-bottom: 30px"
            >测试其效果并调优。</el-row
          >
          <el-row class="sspt-bg-1"> </el-row>
          <el-row class="sspt-bottom clearfix">
            <div>
              <el-row class="content-col18">
                <div class="content-col18-bg"></div>
                <div>人工智能一体机解决方案</div>
              </el-row>
              <el-row class="content-col14 mgb10-0204">
                <div class="content-col14-bg"></div>
                <div class="font14-0204">
                  提供人工智能模型训练，用于端到端的实训场景
                </div>
              </el-row>
              <el-row class="content-col14 mgb10-0204">
                <div class="content-col14-bg"></div>
                <div class="font14-0204">
                  人工智能专业的开箱即用一站式解决方案
                </div>
              </el-row>
              <el-row class="content-col14 mgb10-0204">
                <div class="content-col14-bg"></div>
                <div class="font14-0204">提供适用的实验与科研环境</div>
              </el-row>
              <el-row class="content-col14 mgb10-0204">
                <div class="content-col14-bg"></div>
                <div class="font14-0204">提升学生动手操作、项目实践能力</div>
              </el-row>
            </div>
            <div class="sspt-bg-2"></div>
          </el-row>
        </el-row>
      </el-row>
      <!-- 应用示例 -->
      <el-row class="pd60-0204 yysl-wrapper" id="yysl-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204 title-font28-0204-margin"
            ><span class="title-font28-span">应用示例</span></el-row
          >
          <el-row class="title-text-0204"
            >赛事平台应用示例介绍，包括高校应用及产品应用</el-row
          >
          <el-row class="yysl1">
            <div style="margin-right: 95px">
              <el-row class="content-col18">
                <div class="content-col18-bg"></div>
                <div>高校应用</div>
              </el-row>
              <el-row class="font14-0204 mgb10-0204" style="width: 380px">
                电子科技大学&nbsp;&nbsp;重庆大学&nbsp;&nbsp;重庆邮电大学&nbsp;&nbsp;重庆交通大学&nbsp;&nbsp;</el-row
              >
            </div>
            <div class="yysl1-img-wrapper">
              <div class="yysl1-img1"></div>
              <div class="yysl1-img2"></div>
              <div class="yysl1-img3"></div>
            </div>
          </el-row>
          <el-row class="yysl1" style="margin-bottom: 0">
            <div style="margin-right: 110px">
              <el-row class="content-col18">
                <div class="content-col18-bg"></div>
                <div>产品应用</div>
              </el-row>
              <el-row class="font14-0204 mgb10-0204" style="width: 480px"
                >采用赛事平台的Demo工程，基于Mobilenet
                V1-SSD的物体分类模型，提供给参赛团队做参考，发挥同学们的创造力，给参赛团队更大的发挥空间。</el-row
              >
            </div>
            <div class="yysl1-img-wrapper">
              <div class="yysl1-img4"></div>
              <div class="yysl1-img5"></div>
            </div>
          </el-row>
        </el-row>
      </el-row>
      <!-- 立即报名-fix位置 -->
      <!-- <div
        class="register-now"
        onclick="javascript:window.open('https://www.saikr.com/vse/univ/ciciec/7','_blank')"
      >
        <img
          class="register-now-svg"
          src="@/assets/myMatch/ciciec2023/icon_enroll.svg"
          alt=""
        />
        <div class="register-now-text">立即报名</div>
      </div> -->
    </div>
  </div>
</template>
<script>
import Swiper from "@/utils/swiper-bundle.min.js";
export default {
  data() {
    return {
      showMore: false,
      swiper: null,
    };
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      this.swiper = new Swiper(".swiper-container", {
        modules: [Navigation],
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 40,
        navigation: {
          prevEl: ".icon-fj-chevron-left",
          nextEl: ".icon-fj-chevron-right",
          disabledClass: "my-button-disabled",
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "@/less/swiper-bundle.min.css"; // 单独引入swiper样式防止冲突
</style>